import React from 'react';
import SummaryDatesAndDetails from 'components/FormDate/SummaryDatesAndDetails';

class SummaryDatesList extends React.Component {
  /**
   * Delete a group of dates
   * @param {number} uid of the group of dates
  */
  onRemoveDates = uid => {
    const { eventDates, onRemove } = this.props;
    onRemove({
      allDates: [
        ...eventDates.filter(dates => dates.uid !== uid),
      ],
    });
  }

  render () {
    const { eventDates, onRemove } = this.props;
    return (
      <React.Fragment>
        <p><strong>Date(s) de l&apos;activité</strong></p>
        {eventDates.length > 0 && eventDates.map(dates => (
          <SummaryDatesAndDetails
            key={dates.uid}
            dates={dates}
            onRemove={onRemove && this.onRemoveDates}
          />
        ))}
      </React.Fragment>
    );
  }
}

export default SummaryDatesList;



// WEBPACK FOOTER //
// ./src/components/FormDate/SummaryDatesList.js